<template>
    <div>

        <el-container>
            <el-header><common-header /></el-header>
            <el-container>
                <el-aside width="auto">
                    <common-asideVue />
                </el-aside>
                <el-main class="el-main">
                    <trainorderdetailstwo-right />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import ElContainer from "element-ui/packages/container/src/main";
    import CommonAsideVue from '@/components/CommonAside.vue'
    import CommonHeader from '@/components/CommonHeader.vue'
    import TrainorderdetailstwoRight from "../components/TrainorderdetailstwoRight";

    export default {
        components: {
            TrainorderdetailstwoRight,
            ElContainer,CommonHeader,CommonAsideVue},
        name: "trainorderdetailstwo",
        data () {
            return {}
        },
        methods: {

        }
    }
</script>

<style scoped>
    .el-header{
        padding:0;
    }
</style>